import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import "../../../../assets/css/cms/tools.css";
import Select from "react-select";
import { TiDelete } from "react-icons/ti";
import { postBasicDetails, getPredictorExamDropdown, getPredictorToolType } from "../../../../../store/actions/cms/predictorTools";
import { useSelector } from "react-redux";
import { clearPostBasicDetailResponse } from "../../../../../store/slices/managePredictorTools";
import { getBasicDetails } from "../../../../../store/actions/cms/predictorTools";

const BasicDetail = ({ values, activeStep, setFieldValue, errors, touched, handleSubmit,
    predictorToolTypeData, predictorExamDropdownData, id, handleBlur, showInfoTip, preventTyping,
    handleChangeImage, setFieldTouched, productId, user, dispatch, setSaveNext, postBasicDetailData, showBlockForSEO
}) => {

    const [debounceState, setDebounceState] = useState("");
    const [clientBannerPreview, setClientBannerPreview] = useState("");

    console.log("step1values", values);
    useEffect(() => {
        dispatch(getPredictorToolType({ field_name: "tools_type" }));
        // dispatch(getPredictorExamDropdown({ field_name: "exam" }));
        return (() => {
            setSaveNext(false)
            // dispatch(clearPostBasicDetailResponse())
        })
    }, [])

    useEffect(() => {
        if (postBasicDetailData || productId) {
            dispatch(getBasicDetails({ "product_id": postBasicDetailData?.product_id || productId }))
        }
    }, [postBasicDetailData, productId])

    useEffect(() => {
        if (values?.client_banner && typeof values?.client_banner === "object") {
            const previewUrl = URL.createObjectURL(values.client_banner);
            setClientBannerPreview(previewUrl);
            return () => URL.revokeObjectURL(previewUrl);
        }
        setClientBannerPreview("");
    }, [values?.client_banner]);

    const handleOnInputChangeFields = (type, value) => {
        let params = {};
        params[type] = value;
        let inDebounce = debounceState;
        if (type === "exam" && value) {
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => {
                dispatch(getPredictorExamDropdown({ field_name: "exam", q: value }));
            }, 1000);
            setDebounceState(inDebounce);
        }
    };

    const handleStep1Save = () => {
        console.log("step1valuesonsave", values);

        let data = new FormData();

        // Append values to FormData
        if (id) {
            data.append("product_id", id || null)
        }
        data.append("type", values?.type?.id || null);
        data.append("exam", values?.exam?.id || 0);
        data.append("name", values?.name || null);
        data.append("usage_count_matrix", values?.usage_count_matrix || null);
        data.append("positive_feedback_percentage", values?.positive_feedback_percentage || "");
        data.append("for_web", values?.for_web ? 1 : 0);
        data.append("app_status", values?.app_status ? "published" : "unpublished" || null);
        data.append("page_title", values?.page_title || null);
        data.append("url_alias", values?.url_alias || null);
        data.append("meta_description", values?.meta_description || null);
        data.append("meta_keywords", values?.keywords || null);
        data.append("display_preference", values?.display_preference || 0);
        data.append("gif", values?.gif || "");
        data.append("image", values?.image || "");
        data.append("secondary_image", values?.secondary_image || "");
        data.append("sponser_logo", values?.sponser_logo || "");
        data.append("client_banner", values?.client_banner || "");
        data.append("client_banner_url", values?.client_banner_url || "");
        data.append("enable_sponser_logo", values?.enable_sponser_logo || 0);
        data.append("video", values?.video) || null;
        data.append("smart_registration", values?.smart_registration == true ? 1 : 0 || 0);

        const smartRegistrationData = values?.smart_registration_flow?.map((item) => ({
            id: item?.id,
            name: item.name,
            peak_season: item.peak_season,
            non_peak_season: item.non_peak_season

        }));

        // author_popular_content is getting empty keys so if entity search is not selected then passing author_popular_content as empty []
        if (values?.smart_registration) {
            data.append("smart_registration_data", smartRegistrationData?.length > 0 && JSON.stringify(smartRegistrationData));
        }
        data.append("consume_type", "free")
        data.append("created_by", user?.data?.id)
        data.append("updated_by", user?.data?.id)

        // Debugging FormData content
        data.forEach((value, key) => {
            console.log(`${key}:`, value);
        });

        // Dispatching data
        dispatch(postBasicDetails(data));
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* ******************BASIC DETAIL BLOCK ************** */}

            <div className={"examfilter mb-4"}>
                <h5 className="mb-4">
                    <strong>Basic Details</strong>
                </h5>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Tool Type<sup className="icon_star">*</sup>{" "}
                            </Form.Label>
                            <Select
                                name="type"
                                options={predictorToolTypeData?.tools_type}
                                // defaultValue={!id && type[0]}
                                getOptionLabel={(option) => option.value}
                                getOptionValue={(option) => option.id}
                                value={values?.type}
                                onChange={(data) =>
                                    setFieldValue("type", data)
                                }
                                isClearable={true}
                                isSearchable={true}
                                onBlur={() => {
                                    handleBlur("type");
                                    setFieldTouched("type", true);
                                }}
                                isDisabled
                                placeholder={"Search by Tool"}
                            />
                            {errors.type && touched.type && (
                                <span className="error">{errors.type}</span>
                            )}
                        </Form.Group>
                    </Col>
                    {values?.type?.id == "result_predictor" && (
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Select Exam<sup className="icon_star">*</sup>
                                </Form.Label>
                                <Select
                                    name="exam"
                                    options={predictorExamDropdownData?.exam}
                                    value={values?.exam}
                                    getOptionLabel={(option) => {
                                        if (option.parent_exam_short_name) {
                                            return `${option.parent_exam_short_name} - ${option.exam_name}`;
                                        }
                                        if (option.parent_exam_name) {
                                            return `${option.parent_exam_name} - ${option.exam_name}`;
                                        }
                                        if (option.exam_short_name) {
                                            return `${option.exam_short_name} - ${option.exam_name}`;
                                        }
                                        return option.exam_name;
                                    }}

                                    getOptionValue={(option) => option.id}
                                    onInputChange={(value) => {
                                        handleOnInputChangeFields("exam", value);
                                    }}
                                    placeholder={"Search by Exam"}
                                    onFocus={() =>
                                        dispatch(getPredictorExamDropdown({ field_name: "exam" }))
                                    }
                                    onChange={(data) => setFieldValue("exam", data)}
                                    isClearable={true}
                                    isSearchable={true}
                                    onBlur={() => {
                                        handleBlur("exam");
                                        setFieldTouched("exam", true);
                                    }}
                                />
                                {errors.exam && touched.exam && (
                                    <span className="error">{errors.exam}</span>
                                )}
                            </Form.Group>
                        </Col>
                    )}
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Tool System Name<sup className="icon_star">*</sup>{" "}
                            </Form.Label>
                            <Form.Control
                                name="name"
                                type="text"
                                value={values?.name}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    value = value.replace(/^\s+/g, "");
                                    setFieldValue("name", value)
                                }
                                }
                                onBlur={handleBlur}
                                onKeyDown={(e) =>
                                    preventTyping(e, "name")
                                }
                            />
                            {errors.name &&
                                touched.name && (
                                    <span className="error">
                                        {errors.name}
                                    </span>
                                )}
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Usage Count Metric &nbsp;
                                {showInfoTip("usage_count_matrix")}
                            </Form.Label>
                            <Form.Control
                                name="usage_count_matrix"
                                type="text"
                                value={values?.usage_count_matrix}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    value = value.replace(/^\s+/g, "");
                                    setFieldValue("usage_count_matrix", value)
                                }
                                }
                                onKeyDown={(e) => preventTyping(e, "usage_count_matrix")}
                                onBlur={handleBlur}
                            />
                            {errors.usage_count_matrix && touched.usage_count_matrix && (
                                <span className="error">
                                    {errors.usage_count_matrix}
                                </span>
                            )}
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Positive feedback Percentage &nbsp;
                                {showInfoTip("positive_feedback_percentage")}
                            </Form.Label>
                            <Form.Control
                                name="positive_feedback_percentage"
                                type="text"
                                value={values?.positive_feedback_percentage}
                                onChange={(e) => {
                                    let inputValue = e.target.value;
                                    if (inputValue === "") {
                                        setFieldValue("positive_feedback_percentage", "");
                                        return;
                                    }
                                    const val = inputValue?.match(/^(\d+(\.\d*)?)%?$/);
                                    if (val) {
                                        setFieldValue("positive_feedback_percentage", inputValue);
                                    }
                                }}
                                onBlur={handleBlur}
                                onKeyDown={(e) =>
                                    preventTyping(e, "positive_feedback_percentage")
                                }
                            />
                            {errors.positive_feedback_percentage && touched.positive_feedback_percentage && (
                                <span className="error">
                                    {errors.positive_feedback_percentage}
                                </span>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col md={2}>
                        <Form.Group className="d-flex">
                            <Form.Check
                                type="checkbox"
                                id="web_wap_status"
                                name="for_web"
                                onChange={(e) =>
                                    setFieldValue(
                                        "for_web",
                                        !values.for_web
                                    )
                                }
                                checked={values?.for_web}
                            ></Form.Check>
                            <Form.Label htmlFor="web_wap_status" className="mx-2">
                                {" "}
                                Publishing status (Web/Wap)
                            </Form.Label>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="d-flex">
                            <Form.Check
                                type="checkbox"
                                id="app_status"
                                name="app_status"
                                onChange={(e) => {
                                    setFieldValue(
                                        "app_status",
                                        !values?.app_status
                                    )
                                }
                                }
                                checked={values?.app_status == "published" || values?.app_status ? true : false}
                                value={values?.app_status}

                            ></Form.Check>
                            <Form.Label htmlFor="app_status" className="mx-2">
                                {" "}
                                Publishing status (App)
                            </Form.Label>
                        </Form.Group>
                    </Col>
                </Row>
            </div>
            {/* ******************SEO DETAILS BLOCK ************** */}

            {showBlockForSEO() &&
                <div className={"examfilter  mb-4"}>
                    <h5 className="mb-4">
                        <strong>Input Page SEO Details</strong>
                    </h5>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Page Title<sup className="icon_star">*</sup></Form.Label>
                                <Form.Control
                                    className={"input_pd"}
                                    type="text"
                                    name="page_title"
                                    value={values?.page_title}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/^\s+/g, "");
                                        setFieldValue("page_title", value)
                                    }
                                    }
                                    onBlur={handleBlur}
                                    onKeyDown={(e) =>
                                        preventTyping(e, "page_title")
                                    }
                                />
                                {errors.page_title && touched.page_title && (
                                    <span className="error">
                                        {errors.page_title}
                                    </span>
                                )}
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>URL Alias<sup className="icon_star">*</sup></Form.Label>
                                <Form.Control
                                    className={"input_pd"}
                                    type="text"
                                    name="url_alias"
                                    value={values?.url_alias}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/^\s+/g, "");
                                        setFieldValue("url_alias", value)
                                    }
                                    }
                                    onBlur={handleBlur}
                                    onKeyDown={(e) =>
                                        preventTyping(e, "url_alias")
                                    }
                                />
                                {errors.url_alias && touched.url_alias && (
                                    <span className="error">
                                        {errors.url_alias}
                                    </span>
                                )}
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Meta description<sup className="icon_star">*</sup></Form.Label>
                                <Form.Control
                                    className={"input_pd"}
                                    as="textarea"
                                    name="meta_description"
                                    value={values?.meta_description}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "meta_description",
                                            e.target.value
                                        )
                                    }
                                    onBlur={handleBlur}
                                    onKeyDown={(e) =>
                                        preventTyping(e, "meta_description")
                                    }
                                />
                                {errors.meta_description && touched.meta_description && (
                                    <span className="error">
                                        {errors.meta_description}
                                    </span>
                                )}
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Keywords</Form.Label>
                                <Form.Control
                                    className={"input_pd"}
                                    type="text"
                                    name="keywords"
                                    value={values?.keywords}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/^\s+/g, "");
                                        setFieldValue("keywords", value)
                                    }
                                    }
                                    onBlur={handleBlur}
                                    onKeyDown={(e) =>
                                        preventTyping(e, "keywords")
                                    }
                                />
                                {errors.keywords && touched.keywords && (
                                    <span className="error">
                                        {errors.keywords}
                                    </span>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            }
            {/* ******************INPUT PAGE MEDIA BLOCK ************** */}

            <div className={"examfilter  mb-4"}>
                <h5 className="mb-4">
                    <strong>Input Page Media</strong>
                </h5>
                <Row className="mb-4">
                    <Col md={2}>
                        <span>Input Page Display Preference:<sup className="icon_star">*</sup></span>
                        {errors.display_preference &&
                            touched.display_preference && (
                                <div className="error">
                                    {errors.display_preference}
                                </div>
                            )}
                    </Col>
                    <Col md={2}>
                        <Form.Group className="d-flex">
                            <Form.Check
                                type="radio"
                                id="display_gif"
                                name="display_preference"
                                value={1}
                                checked={values.display_preference == 1}

                                onChange={(e) =>
                                    setFieldValue(
                                        "display_preference",
                                        e.target.value
                                    )
                                }
                            ></Form.Check>
                            <Form.Label htmlFor="display_gif" className="mx-2">
                                {" "}
                                Tool's GIF
                            </Form.Label>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="d-flex">
                            <Form.Check
                                type="radio"
                                id="display_yt_embed"
                                name="display_preference"
                                value={2}
                                checked={values.display_preference == 2}

                                onChange={(e) =>
                                    setFieldValue(
                                        "display_preference",
                                        e.target.value
                                    )
                                }
                            ></Form.Check>
                            <Form.Label
                                htmlFor="display_yt_embed"
                                className="mx-2"
                            >
                                {" "}
                                Tool's YouTube Embedded Video
                            </Form.Label>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="d-flex">
                            <Form.Check
                                type="radio"
                                id="display_img"
                                name="display_preference"
                                checked={values.display_preference == 3}
                                value={3}
                                onChange={(e) =>
                                    setFieldValue(
                                        "display_preference",
                                        e.target.value
                                    )
                                }
                            ></Form.Check>
                            <Form.Label htmlFor="display_img" className="mx-2">
                                {" "}
                                Tool's Images
                            </Form.Label>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label className="d-block">
                                Upload Tool’s GIF &nbsp;
                            </Form.Label>
                            <input
                                name="gif"
                                type="file"
                                accept=".gif"
                                className="mb-2"
                                // value={values?.gif}
                                onChange={(e) => {
                                    const gifFile = e.target.files[0];
                                    if (gifFile) {
                                        if (gifFile.type !== "image/gif") {
                                            alert("Please upload in GIF.");
                                            e.target.value = null; // Reset the input field
                                            setFieldValue("gif", '');
                                        } else {
                                            setFieldValue("gif", gifFile); // Only set value if it is a gif
                                        }
                                    }
                                }}
                                onBlur={handleBlur}
                            />
                            {values?.gif && typeof values?.gif == 'string' ?
                                <div className="media_image_container mt-2">
                                    <a href={values?.gif} target="_blank">
                                        {values?.gif}
                                    </a>
                                    <span className={"delete_image_btn mt-1"} onClick={() => {
                                        setFieldValue("gif", "")
                                    }}>
                                        <TiDelete />
                                    </span>
                                </div>
                                : ""}
                            {errors.gif &&
                                touched.gif && (
                                    <div className="error">
                                        {errors.gif}
                                    </div>
                                )}
                        </Form.Group>

                    </Col>
                    <Col md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label>YouTube Video URL</Form.Label>
                            <Form.Control
                                name="video"
                                type="text"
                                className={"input_pd"}
                                value={values?.video}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    value = value.replace(/^\s+/g, "");
                                    setFieldValue("video", value)
                                }
                                }
                                onBlur={handleBlur}
                            />
                            {errors.video &&
                                touched.video && (
                                    <span className="error">
                                        {errors.video}
                                    </span>
                                )}
                        </Form.Group>
                    </Col>
                    <Col md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label className="d-block ">
                                Upload Tool's Primary Image
                                <sup className="icon_star">*</sup>{" "}
                            </Form.Label>
                            <input
                                name="image"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                className="mb-2"
                                onChange={(e) =>
                                    handleChangeImage(e, "image")
                                }
                                onBlur={handleBlur}
                            />
                            {typeof values.image == "string" && values.image != "" ?
                                <div className="media_image_container mt-2">
                                    <a href={values.image} target="_blank">
                                        {values.image}
                                    </a>
                                    <span className={"delete_image_btn mt-1"} onClick={() => {
                                        setFieldValue("image", "")
                                    }}>
                                        <TiDelete />
                                    </span>
                                </div>
                                : ""}


                        </Form.Group>
                        {errors.image &&
                            touched.image && (
                                <div className="error">
                                    {errors.image}
                                </div>
                            )}
                    </Col>
                    <Col md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label className="d-block ">
                                Upload Tool's Secondary Image{" "}
                            </Form.Label>
                            <input
                                name="secondary_image"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                className="mb-2"
                                onChange={(e) =>
                                    handleChangeImage(e, "secondary_image")
                                }
                                onBlur={handleBlur}
                            />
                            {typeof values.secondary_image == "string" && values.secondary_image != "" ?
                                <div className="media_image_container mt-2">
                                    <a href={values.secondary_image} target="_blank">
                                        {values.secondary_image}
                                    </a>
                                    <span className={"delete_image_btn mt-1"} onClick={() => {
                                        setFieldValue("secondary_image", "")
                                    }}>
                                        <TiDelete />
                                    </span>
                                </div>
                                : ""}
                            {errors.secondary_image &&
                                touched.secondary_image && (
                                    <div className="error">
                                        {errors.secondary_image}
                                    </div>
                                )}
                        </Form.Group>
                    </Col>
                    <Col md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label className="d-block">
                                Upload Client Logo{" "}
                            </Form.Label>

                            {/* Flex row: file input + checkbox */}
                            <div className="d-flex align-items-center gap-3 mb-2">
                                <input
                                    name="sponser_logo"
                                    type="file"
                                    accept=".jpg,.jpeg,.png"
                                    onChange={(e) => handleChangeImage(e, "sponser_logo")}
                                    onBlur={handleBlur}
                                />

                            </div>

                            {/* Image preview */}
                            {typeof values.sponser_logo === "string" && values.sponser_logo !== "" ? (
                                <div className="media_image_container mt-2">
                                    <a href={values.sponser_logo} target="_blank">
                                        {values.sponser_logo}
                                    </a>
                                    <span
                                        className="delete_image_btn mt-1"
                                        onClick={() => setFieldValue("sponser_logo", "")}
                                    >
                                        <TiDelete />
                                    </span>
                                </div>
                            ) : null}

                            {/* Error */}
                            {errors.sponser_logo && touched.sponser_logo && (
                                <div className="error">{errors.sponser_logo}</div>
                            )}
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Check
                            type="checkbox"
                            id="enable_sponser_logo"
                            name="enable_sponser_logo"
                            label="Display Logo"
                            checked={values.enable_sponser_logo}
                            onChange={(e) =>
                                setFieldValue("enable_sponser_logo", e.target.checked ? 1:0)
                            }
                        />
                    </Col>
                    <Col md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label className="d-block">
                                Upload Client Banner
                            </Form.Label>
                            <input
                                name="client_banner"
                                type="file"
                                accept=".gif,.jpg,.jpeg,.png,.webp"
                                className="mb-2"
                                onChange={(e) => handleChangeImage(e, "client_banner")}
                                onBlur={handleBlur}
                            />
                            {values?.client_banner ? (
                                <div className="media_image_container mt-2">
                                    <a
                                        href={typeof values?.client_banner === "string" ? values?.client_banner : clientBannerPreview}
                                        target="_blank"
                                    >
                                        {typeof values?.client_banner === "string" ? values?.client_banner : values?.client_banner?.name}
                                    </a>
                                    <span
                                        className="delete_image_btn mt-1"
                                        onClick={() => setFieldValue("client_banner", "")}
                                    >
                                        <TiDelete />
                                    </span>
                                </div>
                            ) : null}
                            {errors.client_banner && touched.client_banner && (
                                <div className="error">{errors.client_banner}</div>
                            )}
                        </Form.Group>
                    </Col>
                    <Col md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label>Destination URL</Form.Label>
                            <Form.Control
                                name="client_banner_url"
                                type="text"
                                className={"input_pd"}
                                value={values?.client_banner_url}
                                maxLength={500}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    value = value.replace(/^\s+/g, "");
                                    setFieldValue("client_banner_url", value)
                                }}
                                onBlur={handleBlur}
                                onKeyDown={(e) => preventTyping(e, "client_banner_url")}
                            />
                            {errors.client_banner_url && touched.client_banner_url && (
                                <span className="error">{errors.client_banner_url}</span>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
            </div>


            {/* ******************TOOLS SMART REGISTRATION FLOW BLOCK ************** */}

            <div className={"examfilter  mb-4"}>
                <h5 className="d-inline mb-4 me-5">
                    <strong>Manage Tool’s Smart Registration Flow: </strong>
                </h5>
                <Form.Group className="d-inline-flex">
                    <Form.Check
                        id="smart_registration"
                        name="smart_registration"
                        type="checkbox"
                        checked={values?.smart_registration}
                        onChange={(e) =>
                            setFieldValue("smart_registration", !values?.smart_registration)
                        }


                    ></Form.Check>
                    <Form.Label htmlFor="smart_registration" className="mx-2">
                        {" "}
                        Enable Smart Registration
                    </Form.Label>
                </Form.Group>

                {values?.smart_registration_flow?.map((item, index) => {
                    return (
                        <Row className="align-items-center" key={item.id || index}>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{item.name || "Unnamed Field"}</Form.Label>
                                </Form.Group>
                                <hr></hr>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="d-inline-flex">
                                    <Form.Check
                                        id={`smart_registration_data_${index}_peak_season`}
                                        name={`smart_registration_flow[${index}].peak_season`}
                                        type="checkbox"
                                        checked={item.peak_season}
                                        onChange={(e) =>
                                            setFieldValue(
                                                `smart_registration_flow[${index}].peak_season`,
                                                !item.peak_season
                                            )
                                        }
                                    />
                                    <Form.Label
                                        htmlFor={`smart_registration_data_${index}_peak_season`}
                                        className="mx-2"
                                    >
                                        Pre-Fill in Peak season
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="d-inline-flex">
                                    <Form.Check
                                        id={`smart_registration_data_${index}_non_peak_season`}
                                        name={`smart_registration_flow[${index}].non_peak_season`}
                                        type="checkbox"
                                        checked={item.non_peak_season}
                                        // checked={item.non_peak_season ? true : false}

                                        onChange={(e) =>
                                            setFieldValue(
                                                `smart_registration_flow[${index}].non_peak_season`,
                                                !item.non_peak_season
                                            )
                                        }
                                    />
                                    <Form.Label
                                        htmlFor={`smart_registration_data_${index}_non_peak_season`}
                                        className="mx-2"
                                    >
                                        Pre-Fill in Non Peak season
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                    )

                }

                )}

            </div>
            {/* ****************SAVE AND CANCEL BUTTONS***************** */}
            <div className={"my-5 d-flex justify-content-start"}>
                <button
                    className={"exam_button"}
                    type="submit"
                >
                    Save
                </button>
                {activeStep < 1 && (
                    <button
                        className="btnInfo"
                        type="submit"
                        onClick={() => {
                            setSaveNext(true);
                        }}
                        onBlur={() => {
                            setSaveNext(false);
                            // dispatch(clearPostBasicDetailResponse());
                            // handleSubmit(); // Manually trigger the form submission
                        }}

                    >
                        Save & Next
                    </button>
                )}

            </div>
        </form>
    )
}

export default BasicDetail